import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargePriceListResponse from "./chargePriceListResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePriceListsResponse {
  /**
   * The price lists.
   */
  @observable
  @Type(() => ChargePriceListResponse)
  items!: ChargePriceListResponse[];
}
